import { Outlet } from 'react-router'
import { CookieConsentBanner } from '@/components/cookie-consent'

export default function LandingLayout() {
  return (
    <div className="min-h-screen bg-white text-neutral-900 antialiased font-sans selection:bg-orange-primary/20 selection:text-orange-primary">
      <Outlet />
      <CookieConsentBanner />
    </div>
  )
}
